"use strict";
window['renderMenu'] = function () {
    function getAvailableGames() {
        var responseGames = window['menu'].split('|');
        var availableGames = responseGames.filter(function (val) {
            return Object.keys(GAMES).indexOf(val) !== -1;
        });
        return availableGames;
    }
    var gamesToRender = getAvailableGames();
    if (!document.querySelector('#sidebar')) {
        var element = document.querySelector('#terminal-sidebar');
        var html_1 = '';
        gamesToRender.forEach(function (game) {
            return html_1 +=
                "<li class=\"" + (window.location.href.indexOf(GAMES[game].url) > -1 ? 'active' : 'transparentz') + "\" ><a href=\"javascript: void(0)\" " + (game !== 1 ? 'disabled' : '') + "><img alt=\"dog-racing\" src='../shared/img/" + GAMES[game].url + ".png'/><span>" + GAMES[game].name + "</span></a></li>";
        });
        if (element !== null) {
            element.innerHTML = html_1;
        }
    }
    else {
        var element = document.querySelector('#sidebar');
        var html_2 = '';
        gamesToRender.forEach(function (game) {
            return html_2 +=
                "<li>\n                <a class=\"" + (window.location.href.indexOf(GAMES[game].url) > -1 ? 'active' : '') + "\"\n                href=\"javascript: void(0)\" onclick=\"redirectToUrl('" + (BASE_URL + GAMES[game].url) + "')\">" +
                    ("<img alt=\"" + GAMES[game].url + "\"  src='../shared/img/" + GAMES[game].url + ".png' /><span>" + GAMES[game].name + "</span></a>") +
                    "</li>";
        });
        if (element !== null) {
            element.innerHTML = html_2;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/ts/menu/menu.ts
// module id = 2424
// module chunks = 10